"use client"
/* */
import 'invariant';

const Key = "mittwald.flow-core.file.awaitedArrayBuffer";
function isFileWithAwaitedArrayBuffer(file) {
  return Key in file && file[Key] instanceof ArrayBuffer && !file[Key].detached;
}
const addAwaitedArrayBuffer = async (file) => {
  if (isFileWithAwaitedArrayBuffer(file)) {
    return file;
  }
  const arrayBuffer = await file.arrayBuffer();
  Object.assign(file, { [Key]: arrayBuffer });
  return file;
};

export { addAwaitedArrayBuffer, isFileWithAwaitedArrayBuffer };
//# sourceMappingURL=file.mjs.map
